import * as Services from "../../../Services";

export interface IApproveRefundReviewScope extends ng.IScope {
    approveRefundReviewCtrl: ApproveRefundReviewController;
}

export class ApproveRefundReviewController {

    public static $inject = ["$state", "$scope", "$modalInstance", "ProcessReviewInvoiceApiClient", "igsCustomerNumber"];
    public formSubmitted: boolean = false;
    constructor(
        public $state: angular.ui.IStateService,
        public $scope: IApproveRefundReviewScope,
        public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
        protected processReviewInvoiceApiClient: Services.ProcessReviewInvoiceApiClient.IProcessReviewInvoiceApiClient,
        public igsCustomerNumber: string) {
        $scope.approveRefundReviewCtrl = this;
    }

    public submit = () => {
        this.formSubmitted = true;
        this.processReviewInvoiceApiClient.approveRefundReview(this.igsCustomerNumber).then(() => {
            this.$modalInstance.close(true);
        }), () => {
            toastr.error("There was an issue approving this. Please try again later.", "ERROR");
            this.formSubmitted = false;
        };
    }

    public closeModal = () => {
        this.$modalInstance.close(false);
    }
}
